import { mount } from 'svelte'
import './lib/styles/app.css'
import App from './App.svelte'
import { token } from './lib/api'

// Once, before anything else reads location.search: this is what lifts a
// ?token= out of the address bar and puts it in storage. BUG-007.
token()

const target = document.getElementById('app')
if (!target) throw new Error('#app is missing from index.html')

export default mount(App, { target })
